
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/chery",
      function () {
        return require("private-next-pages/chery.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/chery"])
      });
    }
  